import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GridLocaleStorageClearService {
  constructor() {}

  gridStorageClear(gridId?) {
    //gridin enablepersistent en son kı fıltre localstorage da kalıyordu.
    //Bu yuzden FilterSettings localstorage den sılındı
    const value: string = window.localStorage.getItem(gridId);
    if (value != null || value != undefined) {
      const model: Object = JSON.parse(value);
      model['pageSettings'].currentPage = 1;
      model['pageSettings'].totalRecordsCount = 0;
      delete model['filterSettings'];
      delete model['searchSettings'];
      delete model['selectedRowIndex'];
      delete model['sortSettings'];
      delete model['groupSettings'];

      window.localStorage.setItem(gridId, JSON.stringify(model));
    }
  }
}
